// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box[data-v-079ef869] {\n  margin-bottom: 1rem;\n  padding: 1rem;\n}", ""]);
// Exports
module.exports = exports;
